export default () => {
  return (
    window.location.host === "localhost:6060" ||
    window.location.host === "localhost:6063" ||
    window.location.host === "localhost:6064"
  );
};
